import type { UpdateItemRequest } from '@customink/project-service-react-components';
import {
  useProject,
  useUpdateProjectItem,
} from '@customink/project-service-react-components';
import { SYNC_STRATEGIES } from '@customink/project-service-types';
import type { ProjectItem } from '@customink/project-service-types';
import { useCallback } from 'react';

export const useUpdateItem = () => {
  const [trigger, result] = useUpdateProjectItem();

  const curriedTrigger = useCallback(
    (updateProjectItem: UpdateItemRequest) =>
      trigger(updateProjectItem, SYNC_STRATEGIES.CORE_ORDER),
    [trigger],
  );

  return [curriedTrigger, result] as const;
};

export const usePatchUpdateItem = () => {
  const { data: project } = useProject();
  const [trigger, result] = useUpdateProjectItem();

  const patchTrigger = useCallback(
    (projectItemId: string, projectItem: Partial<ProjectItem>) => {
      const previousProjectItem = project?.items?.find(
        (item) => item.id === projectItemId,
      );

      if (!project || !previousProjectItem) return;

      const mergeKeys = ['design', 'fulfillment', 'product'] as const;
      mergeKeys.forEach((key) => {
        projectItem[key] = { ...previousProjectItem[key], ...projectItem[key] };
      });

      const updateItemRequest = {
        projectId: project.id,
        projectItemId,
        projectItem: {
          ...previousProjectItem,
          ...projectItem,
        },
      };

      trigger(updateItemRequest, SYNC_STRATEGIES.CORE_ORDER);
    },
    [project, trigger],
  );

  return [patchTrigger, result] as const;
};
